import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../shared/models/async-value';
import { oneClickOrdersTable } from '../../selectors/one-click-multiple-jobsite.selector';
import { isJobsite, isPointOfDelivery } from '../../helpers/utilities';

export namespace OneClickLocationDisplayer {
  export class HideJobsite extends BaseAsyncValue<boolean> {
    getValue(): Observable<boolean> {
      return this.store.select(oneClickOrdersTable).pipe(
        filter(({ selectedOrder }) => !!selectedOrder),
        map(({ orders, selectedOrder, isFromTable, result }) => {
          if (isFromTable || (orders && orders.length === 1) || result) {
            return isPointOfDelivery(selectedOrder);
          } else {
            return !!(orders && orders.length > 1);
          }
        }),
      );
    }
  }

  export class HidePointOfDelivery extends BaseAsyncValue<boolean> {
    getValue(): Observable<boolean> {
      return this.store.select(oneClickOrdersTable).pipe(
        filter(({ selectedOrder }) => !!selectedOrder),
        map(({ orders, selectedOrder, isFromTable, result }) => {
          if (isFromTable || (orders && orders.length === 1) || result) {
            return isJobsite(selectedOrder);
          } else {
            return !!(orders && orders.length > 1);
          }
        }),
      );
    }
  }
}
